import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CHEF_TAB_LIST, RESTAURANT_CHEF_EDIT } from '../../../../../constants/restaurantConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_RESTAURANT,
} from '../../../../../constants/RoleConsts';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import { allRestaurantChefSelector } from '../../../../property/propertySlice';
import CustomView from '../../CustomView';
import MuiPhoneNumber from 'material-ui-phone-number';
import { decodeMediaKeyValue } from '../../../../../utils/mediaUtils';

const ChefView = (props) => {
  const { chefObj, onViewToggle, toggleDrawer, permissions } = props;
  const allRestaurantChefList = useSelector(allRestaurantChefSelector);
  const [tabValue, setTabValue] = useState(0);
  const [commonDetails, setCommonDetails] = useState([]);
  const [chef, setChef] = useState(null);

  useEffect(() => {
    if (allRestaurantChefList && chefObj) {
      const currentChef = allRestaurantChefList.find((currChef) => currChef.id === chefObj.id);
      if (currentChef) {
        const details = [
          { id: 1, value1: currentChef.restaurantName, name1: 'Restaurant Name' },
          {
            id: 2,
            value1: currentChef.name,
            value2: currentChef.designation,
            name1: 'Chef Name',
            name2: 'Designation',
          },
          {
            id: 3,
            value1: currentChef.specisalisation,
            value2: currentChef.signatureDish,
            name1: 'Specialisation',
            name2: 'Signature Dish',
          },
          { id: 4, value1: currentChef.description || '---', type: 'full', name1: 'Description' },
          {
            id: 5,
            value1: currentChef.email || '---',
            value2: currentChef.phone || '---',
            name1: 'Email Id',
            name2: 'Phone Number',
          },
        ];
        setChef(currentChef);
        setCommonDetails(details);
      }
    }
  }, [allRestaurantChefList, chefObj]);

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, chef);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    if (tabValue === 0 && commonDetails.length > 0) return renderCommonView();
    if (tabValue === 1)
      return (
        <div className='row pt-4 px-3'>
          <div className='row pt-4'>
            <MediaViewer
              images={chef.images}
              videos={(() => {
                const { Video: videoMediaContent } = decodeMediaKeyValue(chef?.mediaContent);
                return videoMediaContent || chef.videos || {};
              })()}
              gifs={(() => {
                const { GIF: gifMediaContent } = decodeMediaKeyValue(chef?.mediaContent);
                return gifMediaContent || chef.gifs || {};
              })()}
              mediaContent={chef.mediaContent}
            />
          </div>
        </div>
      );
  };

  const renderCommonView = () => {
    if (commonDetails?.length > 0) {
      return commonDetails?.map((commonData) => {
        if (commonData.id === 5) {
          return (
            <div key={commonData.id} className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>{commonData?.name1}</div>
                <div className='details-value'>{commonData?.value1}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>{commonData?.name2}</div>
                <div className='details-value'>
                  {commonData?.value2 && commonData?.value2 !== '---' ? (
                    <MuiPhoneNumber
                      value={commonData?.value2}
                      disableAreaCodes
                      countryCodeEditable={false}
                      InputProps={{
                        disableUnderline: true,
                        readOnly: true,
                        style: {
                          color: 'black',
                          fontSize: 'inherit',
                        },
                      }}
                      inputProps={{
                        style: {
                          color: 'black',
                        },
                      }}
                      sx={{ '& svg': { height: '1.2rem' } }}
                    />
                  ) : (
                    '---'
                  )}
                </div>
              </div>
            </div>
          );
        }

        return (
          <CustomView
            key={commonData.id}
            type={commonData.type}
            value1={commonData.value1}
            value2={commonData.value2}
            name1={commonData.name1}
            name2={commonData.name2}
          />
        );
      });
    }
  };

  const onClickEdit = (event) => {
    onOpenDrawer(RESTAURANT_CHEF_EDIT);
  };

  return (
    chef && (
      <>
        <DetailViewLayout
          onClickEdit={onClickEdit}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={CHEF_TAB_LIST}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          createdUserId={chef.createdBy}
          isEditable={permissions[RBAC_TYPE_HOTEL_RESTAURANT] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
          tabClass='col-md-4'
          isHeightIncluded={true}
          title={chef.name}
        />
      </>
    )
  );
};

export default ChefView;
